import { StrictMode } from 'react';
import { createRoot } from 'react-dom/client';

import { App } from './App';
// Every stylesheet is imported here and nowhere else, in the order the bands appear
// down the page, so the cascade is a list somebody can read rather than a consequence
// of which module happened to resolve first. Tokens lead, because everything after
// them reads a custom property; swatch comes last of the pieces because it is the one
// sheet a card's own rules reach into.
import './styles/tokens.css';
import './styles/base.css';
import './styles/masthead.css';
import './styles/federation.css';
import './styles/browse.css';
import './styles/card.css';
import './styles/gauge.css';
import './styles/notes.css';
import './styles/footer.css';
import './styles/swatch.css';

/** The yarn index's React root. */
const container = document.getElementById('root');

if (container === null) {
  throw new Error('index.html is missing #root, so the yarn index cannot mount.');
}

createRoot(container).render(
  <StrictMode>
    <App />
  </StrictMode>,
);
